/* eslint-disable */
// @ts-nocheck

// Scripts used for Audio modules.
// This script is extracted from frontend-scripts to be used in Divi's Dynamic Assets system.
(function ($) {
  $(window).on('et_pb_init_modules', function () {
    window.et_pb_init_audio_modules = function () {
      if (typeof jQuery.fn.mediaelementplayer === 'undefined') {
        return;
      }

      const getOutsideVB = function ($node) {
        return typeof $node === 'string' ? $($node).not('#et-fb-app *') : $node.not('#et-fb-app *');
      };

      getOutsideVB('.et_audio_container').each(function () {
        const $this = $(this);

        if ($this.find('.mejs-container').length > 0) {
          return;
        }

        $this.find('audio').mediaelementplayer(window._wpmejsSettings);
      });
    };

    window.et_pb_init_audio_modules();
  });
})(jQuery);
